// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1-VMr","col":"styles_col__1vJZE"};